import { PriceItem } from '@/types/price-processing.types';

export const extractOptionLabel = (option: unknown): string => {
  if (typeof option === 'string') return option;

  if (option && typeof option === 'object') {
    const candidate = option as { name?: unknown; label?: unknown; value?: unknown; title?: unknown };
    const label = candidate.name ?? candidate.label ?? candidate.value ?? candidate.title;
    return typeof label === 'string' ? label : '';
  }

  return '';
};

export const formatPrice = (price: number | string | null): string => {
  if (price === null || price === undefined || price === '') return '';
  if (price === '1') return '1';
  if (typeof price === 'string') return price;
  return price > 0 ? price.toFixed(2).replace('.', ',') : '';
};

export const normalizeOptionList = <T>(options?: T[]): string[] => {
  if (!options?.length) return [];

  return Array.from(new Set(options.map(extractOptionLabel).filter(Boolean)));
};

export const withAllOption = (options: string[]): string[] => ['Всі', ...options.filter(option => option !== 'Всі')];

export const getDefaultDateTime = () => {
  const now = new Date();
  return new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 19);
};

export const normalizeForComparison = (val: number | string | null | undefined): string | null => {
  if (val === null || val === undefined || val === '') return null;
  if (val === '1') return '1';
  if (typeof val === 'number') return val.toFixed(2).replace('.', ',');
  if (typeof val === 'string') {
    const cleaned = val.replace(',', '.');
    const num = parseFloat(cleaned);
    if (isNaN(num)) return null;
    return num.toFixed(2).replace('.', ',');
  }
  return null;
};

export const stationCellKey = (item: PriceItem, fuel: string): string =>
  item.station_unicode ? `${item.station_unicode}-${fuel}` : `${item.brand}-${item.address || item.region}-${fuel}`;

export const stationRowKey = (item: PriceItem): string =>
  item.station_unicode ? item.station_unicode : `${item.brand}-${item.address || item.region}`;

export const isSameItem = (a: PriceItem, b: PriceItem): boolean => {
  if (a.station_unicode && b.station_unicode) return a.station_unicode === b.station_unicode;
  return a.brand === b.brand && (a.address === b.address || a.region === b.region) && a.province === b.province;
};

export const defaultNotifications = { sendSMS: false, sendMail: false, send1C: false, sendOkkoCore: false };

export const updateDataDate = (data: PriceItem[], date: string): PriceItem[] => {
  return data.map(item => ({ ...item, changeDate: date }));
};

export const getOriginalItem = (item: PriceItem, originalData: PriceItem[]): PriceItem | undefined =>
  originalData.find(orig =>
    item.station_unicode
      ? orig.station_unicode === item.station_unicode
      : orig.brand === item.brand &&
        (orig.address === item.address || orig.region === item.region) &&
        orig.province === item.province
  );

export const isMatchingStationItem = (stationItem: PriceItem, item: PriceItem): boolean =>
  stationItem.region === item.region && stationItem.province === item.province && stationItem.brand === item.brand;

export const getOriginalStationValues = (originalData: PriceItem[], stationItem: PriceItem) =>
  originalData.find(orig =>
    stationItem.station_unicode
      ? orig.station_unicode === stationItem.station_unicode
      : orig.brand === stationItem.brand &&
        orig.address === stationItem.address &&
        orig.province === stationItem.province
  );
